export enum EmailCustomizationTypes {
    TaskNotification = 1,
    UpdateTaskResponsible = 2,
    UserCommentNotification = 3,
    ProcessingActivityStatusUpdated = 4,
    CustomListExport = 5,
    WeeklyTaskNotifications = 6,
    TaskResponsible = 7,
    TaskCompleted = 8,
    TaskReadyForCompletion = 9,
    ContractExpirationReminder = 10,
    UserMentioned = 11,
    AuditResponseSubmittedForSender = 12,
    InternalAssessmentResponseSubmittedForSender = 13,
    AuditResponseCreate = 14,
    AuditResponseSubmittedForRespondent = 15,
    InternalAssessmentResponseCreate = 16,
    InternalAssessmentResponseSubmittedForRespondent = 17,
    AuditReminder = 18,
    AuditReopened = 19,
    DocumentSearchExport = 20,
    PolicyDistribution = 21,
    AuditClosed = 22,
}
